import { ModelRow } from "@mcleod/core";
import { TimelineCardLayout } from "./TimelineCardLayout";
import { AutogenLayoutEventCard } from "./autogen/AutogenLayoutEventCard";
import {ClickEvent, Panel} from "@mcleod/components";
import {DriverEventSlideout} from "../../DriverEventSlideout";

export class EventCard extends AutogenLayoutEventCard implements TimelineCardLayout {
    data: ModelRow;

    onLoad(): void | Promise<void> {
        this.panelEvent.style.overflow = "hidden"; // Force bounds to recalculate
    }

    get expandedHeight(): string|number {
        return this.panelEvent.height;
    }

    get expandedWidth(): string|number {
        return this.panelEvent.width;
    }

    get startDate(): Date {
        return this.data.getDateTime("start_date");
    }

    get endDate(): Date {
        return this.data.getDateTime("end_date");
    }

    get collapsedPanel(): Panel {
        return this.panelCollapsed;
    }

    get overlapSpacer(): Panel {
        return this.panelOverlapSpacer;
    }

    private imageEventIconOnClick(event: ClickEvent) {
        const driverEventSlideout = new DriverEventSlideout();
        const modelRow = this.data;
        driverEventSlideout.showSlideout({
            equipmentId: modelRow?.getString("driver1_id"),
            equipmentName: modelRow?.getString("driver1_name"),
            driverMgrId: modelRow?.getString("driver1_manager"),
            driverMgrName: modelRow?.getString("driver1_manager_name"),
            equipStatusId: modelRow?.getString("id"),
        });
    }
}
